<template>
  <Gallery>
    <template>
      <div class="image">
        <ImageMedia
          class="image__content"
          :size="IMAGE_SIZES.SQUARE"
          :src="mediaObject"
        />
        <button
          v-if="canRemoveImage"
          class="image__remove-button"
          @click="removeImage"
        >
          <i class="material-icons image__remove-button-icon">close</i>
        </button>
      </div>
    </template>
  </Gallery>
</template>

<script>
import { IMAGE_SIZES } from 'rever-media-sdk'

export default {
  components: {
    Gallery: () => import('@/components/utils/Gallery'),
    ImageMedia: () => import('@/components/ImageMedia/ImageMedia.vue'),
  },

  data() {
    return {
      IMAGE_SIZES,
    }
  },

  props: {
    mediaObject: {
      type: Object,
      required: false,
    },

    canRemoveImage: {
      type: Boolean,
      required: false,
    },
  },

  methods: {
    removeImage() {
      this.$emit('removeImage')
    },
  },
}
</script>

<style lang="scss" scoped>
.image {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100%;
  background-color: $color-blue-grey-lighten3;
  border-radius: 4px;

  &__content {
    width: 100%;
    height: 100%;
    background-size: cover;
    cursor: pointer;
    border-radius: 4px;
    object-fit: cover;
  }

  &__remove-button {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 8px;
    right: 8px;
    background-color: $color-black;
    cursor: pointer;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: none;
  }

  &__remove-button-icon {
    color: $color-white;
    font-size: 16px;
  }
}
</style>
